import "./App.css";
import {
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import axios from 'axios';

import Login from "./Components/Auth/Login";
import Signup from "./Components/Auth/Signup";
import Home from "./Components/Home";
import Dashboard from "./Components/Dashboard";
import ApplyForLoan from "./Components/ApplyForLoan";
import { useEffect } from "react";
import ForgotPassword from "./Components/Auth/ForgotPassword";
import EmailConfirmation from "./Components/Auth/EmailConfirmation";
import ChangePassword from "./Components/Auth/ChangePassword";
import Payments from "./Components/Dashboard/Payments-History/Payments";
import Pay from "./Components/Dashboard/Pay/Pay";
import Profile from "./Components/Dashboard/Profile/Profile";
import EditFullname from "./Components/Dashboard/Profile/EditFullname";
import EditPhonenumber from "./Components/Dashboard/Profile/EditPhonenumber";
import NewEmail from "./Components/Dashboard/Profile/NewEmail";
import VerifyEmail from "./Components/Dashboard/Profile/VerifyEmail";
import ChangeEmail from "./Components/Dashboard/Profile/ChangeEmail";
import Services from "./Components/Services";
import About from "./Components/About";

// 1. Add this import at the top of the file
import { useDispatch } from 'react-redux';
import { actions } from './store';


// 2. Add this inside your component function (usually at the very top)


function App() {
  const dispatch = useDispatch();
  const url = process.env.REACT_APP_API_URL
  // const url = 'https://rent-project-ee14.onrender.com'
  // Commit so that vercel can deploy
  // new commit for transaction history, nee push so vercel can deploy
  const location = useLocation()

useEffect(() => {

  const token =
    localStorage.getItem(
      'access_token'
    )


  const isDashboard =
    location.pathname.startsWith(
      '/dashboard'
    )


  if (!token || !isDashboard) {
    return
  }


  const headers = {
    Authorization:
      `Bearer ${token}`
  }


  const loadUser = async () => {

    try {

      const response = await axios.get(
        `${url}/auth/me`,
        { headers }
      )


      console.log(
        'CURRENT USER:',
        response.data
      )


      dispatch(
        actions.updateUser(
          response.data
        )
      )


    } catch (error) {

      console.error(
        'Unable to load user:',
        error
      )

    }

  }


  const loadTransactionHistory =
    async () => {

      try {

        const response = await axios.get(
          `${url}/pay/payment-history`,
          { headers }
        )


        dispatch(
          actions.updateTransactions(
            response.data
          )
        )


      } catch (error) {

        console.error(
          'Unable to load transaction history:',
          error
        )

      }

    }


  loadUser()

  loadTransactionHistory()


}, [
  location.pathname,
  url,
  dispatch
])

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services/" element={<Services />} />
        <Route path="/about/" element={<About />} />
        {/* Authentications route */}
        <Route path="/auth/signup/" element={<Signup />} />
        <Route path="/auth/forgot_password/" element={<ForgotPassword />} />
        <Route path="/auth/conf_email/" element={<EmailConfirmation />} />
        <Route path="/auth/change_password/:token" element={<ChangePassword />} />
        <Route path="/auth/signin/" element={<Login />} />
        <Route path="/apply-for-loan" element={<ApplyForLoan/>} />
        <Route path="/dashboard/home" element={<Dashboard />} />
        <Route path="/dashboard/payments/" element={<Payments />} />
        <Route path="/dashboard/pay/" element={<Pay />} />
        <Route path="/dashboard/profile/" element={<Profile />} />
        <Route path="/dashboard/profile/edit_fullname" element={<EditFullname />} />
        <Route path="/dashboard/profile/edit_phone_number" element={<EditPhonenumber />} />
        <Route path="/auth/new_email/:token" element={<NewEmail />} />
        <Route path="/auth/verify_email/:token" element={<VerifyEmail />} />
        <Route path="/auth/change_email/:token" element={<ChangeEmail />} />
      </Routes>
    </div>
  );
}
export default App;